import { Input } from "antd";
import { HelperText } from "../elements/HelperText";
import { Stack } from "@mui/material";
import { FormLabel } from "../elements/FormLabel";
const { TextArea } = Input;

export const GenericInput = ({
  placeholder,
  label,
  rows,
  suffix,
  prefix,
  helperText,
  type,
  required = false,
  optional = false,
  onChange,
  value,
  name,
  updateFormValue,
  ...props
}) => {
  return (
    <Stack spacing={1}>
      <FormLabel optional={optional} required={required}>
        {label}
      </FormLabel>
      {rows ? (
        <TextArea
          name={name}
          onChange={onChange}
          value={value}
          placeholder={placeholder || label}
          rows={rows || 2}
          required={required}
        />
      ) : (
        <Input
          name={name}
          onChange={(e) =>
            type === "tel" ? updateFormValue(name, e.target.value) : onChange(e)
          }
          placeholder={placeholder || label}
          addonAfter={suffix}
          value={value}
          addonBefore={prefix}
          type={type}
          required={required}
          {...props}
        />
      )}
      <HelperText text={helperText} />
    </Stack>
  );
};
